import { c as _c } from "react/compiler-runtime";
import { AFFILIATE_PROGRAM_SETTINGS_API } from 'modules/profile/affiliate-program-settings/api/affiliate-program-settings-api';
import { AffiliateProgramLinksApiInterface, AffiliateProgramPaymentInterface, AffiliateProgramSettingsInterface } from 'modules/profile/affiliate-program-settings/types/affiliate-program-settings-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import useSWR from 'swr';
export function useAffiliateProgramSettings(t0) {
  const $ = _c(16);
  const {
    pagination,
    limit
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== user) {
    t2 = () => {
      if (user) {
        return `${AFFILIATE_PROGRAM_SETTINGS_API}/program`;
      }
      return null;
    };
    $[1] = user;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: affiliateProgram,
    mutate: mutateAffiliateProgram
  } = useSWR(t2, fetcher);
  let t3;
  if ($[3] !== user) {
    t3 = () => {
      if (user) {
        return `${AFFILIATE_PROGRAM_SETTINGS_API}/payment`;
      }
      return null;
    };
    $[3] = user;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: affiliateProgramPayment,
    mutate: mutatePayment
  } = useSWR(t3, fetcher);
  let t4;
  if ($[5] !== limit || $[6] !== pagination || $[7] !== user) {
    t4 = () => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${AFFILIATE_PROGRAM_SETTINGS_API}/links?pagination[limit]=${limit}`;
      } else {
        if (user && pagination.startFromId && limit) {
          return `${AFFILIATE_PROGRAM_SETTINGS_API}/links?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`;
        }
      }
      return null;
    };
    $[5] = limit;
    $[6] = pagination;
    $[7] = user;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    data: affiliateProgramLinks,
    mutate: mutateLinks
  } = useSWR(t4, fetcher);
  let t5;
  if ($[9] !== affiliateProgram || $[10] !== affiliateProgramLinks || $[11] !== affiliateProgramPayment || $[12] !== mutateAffiliateProgram || $[13] !== mutateLinks || $[14] !== mutatePayment) {
    t5 = {
      affiliateProgram,
      mutateAffiliateProgram,
      affiliateProgramPayment,
      mutatePayment,
      affiliateProgramLinks,
      mutateLinks
    };
    $[9] = affiliateProgram;
    $[10] = affiliateProgramLinks;
    $[11] = affiliateProgramPayment;
    $[12] = mutateAffiliateProgram;
    $[13] = mutateLinks;
    $[14] = mutatePayment;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}